import Grid from '@material-ui/core/Grid';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React, {useState} from 'react';

const Signature = ({
  user,
  customPadding,
  errors,
  touched,
}: {
  user: string;
  customPadding: string | null;
  errors: any;
  touched: any;
}) => {
  const [errorPass, setErrorPass] = useState<{
    error: boolean;
    errorMessage: string;
  }>({error: false, errorMessage: ''});

  const validatePassword = (value: string) => {
    let error;
    if (typeof value == 'undefined' || value.length === 0) {
      error = i18n2._('Please provide a password');
      setErrorPass({error: true, errorMessage: error});
    } else {
      setErrorPass({error: false, errorMessage: ''});
    }
  };

  return (
    <>
      <Grid
        style={{padding: customPadding ? customPadding : 20}}
        container
        spacing={3}
      >
        <Grid item xs={12}>
          <Field
            label={i18n2._('Reason')}
            name={'reason'}
            variant="outlined"
            fullWidth
            required
            component={TextField}
            multiline
            helperText={errors && errors.reason}
          />
        </Grid>
        <Grid item sm={6} xs={12} style={{padding: 20}}>
          <Field
            label={i18n2._('User')}
            name={'user'}
            variant="standard"
            fullWidth
            component={TextField}
            value={user}
            defaultValue={user}
            disabled={true}
          />
        </Grid>
        <Grid item sm={6} xs={12} style={{padding: 20}}>
          <Field
            label={i18n2._('Password')}
            name={'pass'}
            variant="standard"
            fullWidth
            required
            component={TextField}
            type="password"
            validate={(value: string) => validatePassword(value)}
            helperText={
              touched.pass && errorPass.error && errorPass.errorMessage
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Signature;
